import { throttle } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Wix from '../../services/wix-sdk-polyfill';

class ScrollListener extends Component {
  componentDidMount() {
    this.startListeningToOuterScroll();
  }

  componentWillUnmount() {
    Wix.removeEventListener(Wix.Events.SCROLL, this.handleOuterScroll);
  }

  startListeningToOuterScroll() {
    Wix.addEventListener(Wix.Events.SCROLL, this.handleOuterScroll);
  }

  handleOuterScroll = throttle(scroll => {
    this.props.onScroll(scroll);
  });

  render() {
    return <div />;
  }
}

ScrollListener.propTypes = {
  onScroll: PropTypes.func.isRequired,
};

export default ScrollListener;
